export const BANK_STEP_NOT_FINISHED_MESSAGE =
  "Your bank wasn't linked because Stripe's window closed before the last step. Please try again and finish every step.";
export const BANK_STEP_FAILED_MESSAGE = "Stripe couldn't link your bank. Please try again.";
export const BANK_MICRODEPOSITS_MESSAGE =
  'Stripe will send two small deposits to your bank in 1-2 business days. Enter them from Payment Methods to finish adding this bank account.';

// The API refuses to confirm a bank account whose Stripe bank step never finished.
// Older API builds answer with the generic refusal text.
const API_BANK_STEP_NOT_FINISHED_MESSAGES = [
  "We didn't get your bank details from Stripe. Please connect your bank again and finish every step.",
  'This action is not allowed!',
];

export interface StripeBankSetupResult {
  setupIntent?: { status?: string };
  error?: { message?: string };
}

/**
 * Stripe's collectBankAccountForSetup resolves (it doesn't throw) when the customer closes
 * its window: the SetupIntent stays `requires_payment_method` and there is nothing to confirm.
 * @see https://docs.stripe.com/js/payment_intents/collect_bank_account_for_setup
 */
export function bankStepProblemMessage(result: StripeBankSetupResult | null | undefined): string | null {
  if (result?.error) return BANK_STEP_FAILED_MESSAGE;
  if (!result?.setupIntent || result.setupIntent.status === 'requires_payment_method') {
    return BANK_STEP_NOT_FINISHED_MESSAGE;
  }
  return null;
}

export function apiErrorMessage(error: { message?: string; error?: { message?: string } } | null | undefined): string {
  return error?.error?.message || error?.message || '';
}

/** The not-finished message when the API refused to confirm because Stripe's bank step never finished, else null. */
export function bankStepRefusalMessage(error: { message?: string; error?: { message?: string } } | null | undefined): string | null {
  return API_BANK_STEP_NOT_FINISHED_MESSAGES.includes(apiErrorMessage(error)) ? BANK_STEP_NOT_FINISHED_MESSAGE : null;
}

/** Whether a confirmed bank account still waits for Stripe's microdeposits. */
export function waitsForMicrodeposits(paymentMethod: { action_required?: string } | null | undefined): boolean {
  return paymentMethod?.action_required === 'collect_microdeposit_info';
}
